

<span style="filter: invert(10%) sepia(96%) saturate(5335%) hue-rotate(340deg) brightness(95%) contrast(97%);" >
    <slot />
</span>